import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mwp-dashboard-boxes',
    templateUrl: 'dashboard-boxes.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})

export class DashboardBoxesComponent implements OnInit {
    @Input() labelOne: string;
    @Input() labelTwo: string;
    @Input() amountOne: string;
    @Input() amountTwo: string;
    @Input() fullHeight: boolean;

    constructor() { }

    ngOnInit() { }
}